var map = {
	"./about/about.vue": "gsXr",
	"./askri/askri.vue": "BRkJ",
	"./cooperate/cooperate.vue": "ecIT",
	"./index/index.vue": "YPWR",
	"./plan/plan.vue": "tekS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "v1t/";


//////////////////
// WEBPACK FOOTER
// ./src/view .vue
// module id = v1t/
// module chunks = 1